<template>
  <BreadCrumb PageTitle="Détails de l'abonné" />
  <ViewAbonne />
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ViewAbonne from "../../components/Abonne/ViewAbonne.vue";

  export default defineComponent({
    name: "ViewAbonnePage",
    components: {
      BreadCrumb,
      ViewAbonne,
    },
  });
</script>